import React from "react";
import Logo from "../../assets/E.ON_Next_logo.svg";

/** Confirmation page */
const ConfirmationPage = (): JSX.Element => (
  <main className="main">
    <section className="logo-container">
      <img className="main-logo" alt="E.ON Next logo" src={Logo} />
    </section>
    <section className="text">
      <h5>Thanks for your feedback!</h5>
      <h1>You can now close this window</h1>
    </section>
  </main>
);

export default ConfirmationPage;
